import { combineReducers } from 'redux'

export const rootReducer = combineReducers({
  // TODO: 移除下面这一行，然后配置需要 combine 的 reducer
  ['default']: (state = null) => state,
})
